import * as React from "react";
import Api from "../../Api/Api";
import * as htmlToImage from "html-to-image";
import azure from "../../utils/azure";
import emailjs from "emailjs-com";
import Button from "@mui/material/Button";
import language from "../../assets/data/language";
import PropTypes from "prop-types";

const instanceConfig = {
  MARATHON: {
    main: { width: 806, height: 600},
    nameTop: 140,
    date: {top: 277, right: -150}
  },
  CREWBELT: {
    main: { width: 880, height: 620},
    nameTop: 120,
    date: {top: 290, right: -190}
  }
}


const RenderCert = ({data, spanish, template, score, regenerate, urlToUpdate, user}) => {
  const [generating, setGenerating] = React.useState(true)
  const certUrl = React.useRef(false);
  const domEl = React.useRef(null);
  const certDone = React.useRef(false);
  const [bgImageSrc, setBgImageSrc] = React.useState(null);
  const bgReadyPromiseRef = React.useRef(null);
  const bgReadyResolveRef = React.useRef(null);
  if (!bgReadyPromiseRef.current) {
    bgReadyPromiseRef.current = new Promise(resolve => {
      bgReadyResolveRef.current = resolve;
    });
  }

  React.useEffect(() => {
    const url = `/${process.env.REACT_APP_APP_INSTANCE}_BLANK.jpg`;
    fetch(url)
      .then(r => r.blob())
      .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      }))
      .then(dataUrl => {
        setBgImageSrc(dataUrl);
        setTimeout(() => bgReadyResolveRef.current?.(), 0);
      })
      .catch(() => {
        setBgImageSrc(`/${process.env.REACT_APP_APP_INSTANCE}_BLANK.jpg`);
        setTimeout(() => bgReadyResolveRef.current?.(), 0);
      });
  }, []); 

  // const link = document.createElement('a');

  const createSaveCert = async () => {
    const savedQuiz = await Api.createCert(data);
    let quiz = savedQuiz?.data?.quiz

    await bgReadyPromiseRef.current; // background data URL is in DOM; safe to capture

    // eslint-disable-next-line
    const url = await htmlToImage.toBlob(document.getElementById("domEl"), {quality: 0.95, skipFonts: true})

      .then(function (dataUrl) {
        return azure.uploadCertNew(dataUrl, `${data.userID || data.emp_email}/${data.cert_name}.png`, data, quiz)
      })
    data.certificate_url = url;
    let emailData = {
      service_id: process.env.REACT_APP_APP_INSTANCE === "CREWBELT" ? "service_bbme5kk" : "service_27j4zif",
      template_id: process.env.REACT_APP_APP_INSTANCE === "CREWBELT" ? "template_c0s9ucl" : "prod_template",
      user_id: 'uLBRMNt_Pnb3kQlS7',
      template_params: data
    };

    await emailjs.send(emailData.service_id, emailData.template_id, emailData.template_params, emailData.user_id)
      .then((result) => {
        certDone.current = true
      }, (error) => {
        console.log(error, false)
        return error
      });
    return url;
  }

  const updateCert = async () => {
    certDone.current = true; // block re-render from triggering a second call
    await bgReadyPromiseRef.current; // background data URL is in DOM; safe to capture

    // const savedQuiz = await Api.createCert(data);
    // eslint-disable-next-line
    const url = await htmlToImage.toBlob(document.getElementById(regenerate ? "domEl-regen" : "domEl"), {quality: 0.95, skipFonts: true})
      .then(function (dataUrl) {
        return azure.updateCert(dataUrl, `${user.UserID}/${data.name}`, data.certificate.metadata, urlToUpdate)
      })
    return url;
  }

  if(!certDone.current && !regenerate) createSaveCert().then(url => {
    certUrl.current = url;
    setGenerating(false)
    // send email
  }).catch(err => {
    console.log(err, "FAILED TO CRAETE CERT?")
    setGenerating(false)
  })

  if(!certDone.current && regenerate) updateCert().then(url => {
    certUrl.current = url;
    setGenerating(false)
    // send email
  }).catch(err => {
    console.log(err, "FAILED TO CRAETE CERT?")
    setGenerating(false)
  })

  const downloadImage = async () => {
    htmlToImage.toPng(document.getElementById(regenerate ? "domEl-regen" : "domEl"), { quality: 0.95, skipFonts: true })
      .then(function (dataUrl) {
        // azure.uploadCertNew(dataUrl,  `${data.userId || data.emp_email}/${data.cert_name}.jpeg`, data)
        let link = document.createElement('a');
        link.download = regenerate ? data.name : `${ data.cert_name}.png`;
        link.href = dataUrl;
        link.click();
      });
  }

  return <div>
    <p style={{textAlign: 'center', marginTop: 10, fontWeight: '600'}}>
      {(score >= 70) && <>
        {generating ? "Sending email..." : "A copy of your results has been emailed to you and to the training department to be kept on record in your file. "}
      </>}
    </p>
    <div style={{
      overflow: "hidden",
      backgroundColor: 'black',
      maxHeight: 200,
      maxWidth: 600,
      position: 'relative',
      border: '3px solid #d94d41',
      marginBottom: 10,
    }}>
      <Button
        onClick={downloadImage}
        variant="contained"
        style={{
          position: 'absolute',
          top: "50%",
          zIndex: 99,
          left: "50%",
          transform: "translate(-50%, -50%)"
        }}
      >{language.common.download(spanish)}</Button>
      <div style={{opacity: .5}}>
        <div style={{width: instanceConfig[process.env.REACT_APP_APP_INSTANCE].main.width, height: instanceConfig[process.env.REACT_APP_APP_INSTANCE].main.height}} id={regenerate ? "domEl-regen" : "domEl"} ref={domEl}>
          <div
            style={{
              width: instanceConfig[process.env.REACT_APP_APP_INSTANCE].main.width,
              height: instanceConfig[process.env.REACT_APP_APP_INSTANCE].main.height,
              backgroundImage: `url(${bgImageSrc || `/${process.env.REACT_APP_APP_INSTANCE}_BLANK.jpg`})`,
              backgroundSize: "cover"
            }}>
            <h3
              style={{
                margin: 0,
                zIndex: 1,
                position: "relative",
                top: instanceConfig[process.env.REACT_APP_APP_INSTANCE].nameTop,
                fontSize: 30,
                textAlign: "center"
              }}>{regenerate ? user.FirstName + " " + user.LastName : data.emp_name}</h3>
            <h3
              style={{
                margin: 0,
                zIndex: 1,
                position: "relative",
                top: 210,
                fontSize: 30,
                textAlign: "center"
              }}>{regenerate ? data.quiz : data.certification_title}</h3>
            <p
              style={{
                margin: 0,
                zIndex: 1,
                position: "relative",
                top: instanceConfig[process.env.REACT_APP_APP_INSTANCE].date.top,
                fontSize: 15,
                textAlign: "center",
                right: instanceConfig[process.env.REACT_APP_APP_INSTANCE].date.right
              }}>{regenerate ? data.date : data.todays_date}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

}
RenderCert.propTypes = {
  data: PropTypes.any,
  spanish: PropTypes.bool,
  template: PropTypes.string,
  user: PropTypes.any,
  // setGenerating: PropTypes.func,
  score: PropTypes.any,
  regenerate: PropTypes.bool,
  urlToUpdate: PropTypes.string,
}

export default RenderCert;
